import Home from "@/views/adm/Home";

import SystemParametersList from "@/views/adm/systemParameters/SystemParametersList";
import SystemParametersEdit from "@/views/adm/systemParameters/SystemParametersEdit";

import UserSettingList from "@/views/adm/userSetting/UserSettingList";
import UserSettingEdit from "@/views/adm/userSetting/UserSettingEdit";

import RoleList from "@/views/adm/role/RoleList";
import RoleEdit from "@/views/adm/role/RoleEdit";

import ThreadHistoryList from "@/views/adm/threadHistory/ThreadHistoryList";

import IntegrationMessageList from "@/views/adm/integrationMessage/IntegrationMessageList";
import integrationMessageTest from "@/views/adm/integrationMessage/integrationMessageTest";

import IntegrationMessageConfigList from "@/views/adm/integrationMessageConfig/IntegrationMessageConfigList";
import IntegrationMessageConfigEdit from "@/views/adm/integrationMessageConfig/IntegrationMessageConfigEdit";

import UserPreferencesEdit from "@/views/adm/userPreferences/UserPreferencesEdit";

import userCenter from "@/views/adm/userCenter";

import DataFieldList from "@/views/adm/dataField/DataFieldList";
import DataFieldEdit from "@/views/adm/dataField/DataFieldEdit";

import ChartList from "@/views/adm/chart/ChartList";
import ChartEdit from "@/views/adm/chart/ChartEdit";

import log from "@/views/adm/log/LogList"

const metaObject = { requiresAuth: true, roles: ['mmf'] };

export default [{
        path: "/adm",
        name: "home-adm",
        component: Home,
        meta: metaObject
    },
    {
        path: "/adm/userCenter",
        name: "userCenter",
        component: userCenter,
        meta: metaObject
    },
    {
        path: "/adm/log",
        name: "log",
        component: log,
        meta: metaObject
    },
    {
        path: "/adm/userPreferences",
        name: "userPreferences",
        component: UserPreferencesEdit,
        meta: metaObject
    },
    {
        path: "/adm/systemParameters",
        name: "systemParametersList",
        component: SystemParametersList,
        meta: metaObject
    },
    {
        path: "/adm/systemParameters/edit",
        name: "systemParametersEdit",
        component: SystemParametersEdit,
        meta: metaObject
    },
    {
        path: "/adm/userSetting",
        name: "userSettingList",
        component: UserSettingList,
        meta: metaObject
    },
    {
        path: "/adm/userSetting/edit",
        name: "userSettingEdit",
        component: UserSettingEdit,
        meta: metaObject
    },
    {
        path: "/adm/role",
        name: "roleList",
        component: RoleList,
        meta: metaObject
    },
    {
        path: "/adm/role/edit",
        name: "roleEdit",
        component: RoleEdit,
        meta: metaObject
    },
    {
        path: "/adm/threadHistory",
        name: "threadHistoryList",
        component: ThreadHistoryList,
        meta: metaObject
    },
    {
        path: "/adm/integrationMessage",
        name: "integrationMessageList",
        component: IntegrationMessageList,
        meta: metaObject
    },
    {
        path: "/adm/integrationMessageConfig",
        name: "integrationMessageConfigList",
        component: IntegrationMessageConfigList,
        meta: metaObject
    },
    {
        path: "/adm/integrationMessageConfig/edit",
        name: "integrationMessageConfigEdit",
        component: IntegrationMessageConfigEdit,
        meta: metaObject
    },
    {
        path: "/adm/integrationMessageTest",
        name: "integrationMessageTest",
        component: integrationMessageTest,
        meta: metaObject
    },
    {
        path: "/adm/dataField",
        name: "dataFieldList",
        component: DataFieldList,
        meta: metaObject
    },
    {
        path: "/adm/dataField/edit",
        name: "dataFieldEdit",
        component: DataFieldEdit,
        meta: metaObject
    },
    {
        path: "/adm/chart",
        name: "chartList",
        component: ChartList,
        meta: metaObject
    },
    {
        path: "/adm/chart/edit",
        name: "chartEdit",
        component: ChartEdit,
        meta: metaObject
    }
]